/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step6_RuleInputs */

const en_dr_step6_rule = /** @type {(inputs: Dr_Step6_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing is "done" until it's handed off into a plan`)
};

const id_dr_step6_rule = /** @type {(inputs: Dr_Step6_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum "selesai" sebelum diserahkan menjadi plan`)
};

/**
* | output |
* | --- |
* | "Nothing is \"done\" until it's handed off into a plan" |
*
* @param {Dr_Step6_RuleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step6_rule = /** @type {((inputs?: Dr_Step6_RuleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step6_RuleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step6_rule(inputs)
	return en_dr_step6_rule(inputs)
});